// 9fbef606107a605d69c0edbcd8029e5d
export default {
  LOAD_HEADER_DATA: 'LOAD_HEADER_DATA',
  OPEN_NAVIGATION_DRAWER: 'OPEN_NAVIGATION_DRAWER',
  CLOSE_NAVIGATION_DRAWER: 'CLOSE_NAVIGATION_DRAWER',
  HIDE_DRAWER_INFO_SECTION: 'HIDE_DRAWER_INFO_SECTION',
  OPEN_MINI_BAG: 'OPEN_MINI_BAG',
  CLOSE_MINI_BAG: 'CLOSE_MINI_BAG',
  CART_ITEM_COUNT: 'CART_ITEM_COUNT',
  UPDATE_CART_MANUALLY: 'UPDATE_CART_MANUALLY',
  REMOVE_L1_PANEL_TIMEOUT: 'REMOVE_L1_PANEL_TIMEOUT',
  UPDATE_SBP_EVENT: 'UPDATE_SBP_EVENT',
  SET_CONDENSED_STATUS: 'SET_CONDENSED_STATUS',
  OPEN_ACCOUNT_DRAWER: 'OPEN_ACCOUNT_DRAWER',
  CLOSE_ACCOUNT_DRAWER: 'CLOSE_ACCOUNT_DRAWER',
};
